import React from 'react'

import Button from 'Components/Button'
import Checkbox from 'Components/Checkbox'
import Input from 'Components/Input'
import { SVGArrow, SVGTrashSmall } from 'Components/SVGCollection'

import cn from 'classnames'
import cg from 'Scss/app.scss'
import btnCss from 'Components/Button/Button.scss'
import prnt from 'Components/Profile/ProfileNavListItem/ProfileNavListItem.scss'
import cl from './AddressListFoldableAddressForm.scss'
import cla from '../BillingAddresses/Addresses.scss'
import Form from 'Components/Form'
import { NEW_ADDRESS_ID, formatAddress, processPostcodes, formatAddressWithName } from 'Utils/helpers/addressHelper'
import { BillingAddressFragment, postcodes, postcodesVariables } from 'Utils/api/gql/types'
import _app from 'Pages/_app'
import postCodes from 'Utils/api/gql/queries/postCodes'
import InputWrapper from 'Components/InputWrapper'
import { isEqual } from 'Utils/helpers/misc'
import DropdownSelect from 'Components/Dropdown/DropdownSelect'
import Badge from '../ProfileNavListItem/Badge'

type OwnProps = {
  onChange: (address: BillingAddressFragment) => void
  opened?: boolean
  address: BillingAddressFragment
  isFetching?: boolean
  noDropDown?: boolean
  errors: Redux.IFormErrors<BillingAddressFragment>
  hideDeleteButton?: boolean
} & ({
  onClick: () => void
  onSaveClick: () => void
  onResetClick: () => void
  onDeleteClick: () => void
  fieldsOnly?: false | undefined
} | {
  onClick?: () => void
  onSaveClick?: () => void
  onResetClick?: () => void
  onDeleteClick?: () => void
  fieldsOnly: true
})

type PropType = OwnProps & {divRef: React.Ref<HTMLDivElement>}
type StateType = {
  cities: string[]
  streets: string[]
  postcodeFetching: boolean
  postcodeError: string | undefined
}

class BillingAddressForm extends React.Component<PropType, StateType> {
  timeout: number | null = null
  state: StateType = {
    cities: [],
    streets: [],
    postcodeFetching: false,
    postcodeError: undefined
  }

  updateCitiesByPostcode = async (postcode: string | number) => {
    postcode = Number(postcode)
    if (postcode < 1000 || postcode > 9999) {
      this.setState({ cities: [] })
      return
    }

    this.setState({ postcodeFetching: true })

    try {
      const result = await _app.apolloClient.query<postcodes, postcodesVariables>({
        query: postCodes,
        variables: { filters: { postcode } }
      })

      const { postcodes } = result.data
      const { cities, streets } = processPostcodes(postcodes)

      let newAddress = { ...this.props.address }

      if (cities.length && !this.props.address.city) {
        newAddress.city = cities[0]
      }

      if (!isEqual(this.props.address, newAddress)){
        this.props.onChange(newAddress)
      }

      this.setState({ cities, streets })
    } catch (e) {
      this.setState({ cities: [], streets: [] })
    }
    this.setState({ postcodeFetching: false })
  }

  componentDidMount() {
    const { postcode } = this.props.address

    this.updateCitiesByPostcode(postcode)
  }

  handleChange = async (name: keyof BillingAddressFragment, value: string | boolean | null) => {
    this.props.onChange({
      ...this.props.address,
      [name]: value
    })

    if (name === 'postcode' && typeof value === 'string') {
      this.updateCitiesByPostcode(value)
    }
  }

  renderForm = (isNewAddress?: boolean, isFetching?: boolean, isValidPostcode?: boolean, isGoodId?: boolean) =>
    <Form onChange={this.handleChange} values={this.props.address} errors={this.props.errors}>
      <fieldset>
        <div className={cg.gridX}>
          {isGoodId && <div className={cg.cell}>
            <strong>A GoodID címek csak a GoodID felületén keresztül módosíthatóak!</strong>
          </div>}
          <div className={cg.cell}>
            <InputWrapper
              name='city'
              label='Magánszemély/Cég *'
            >
              {isGoodId
                ? (this.props.address.is_company ? 'Cég' : 'Magánszemély')
                : <DropdownSelect
                    name='is_company'
                    items={[{ title: 'Magánszemély', value: false }, { title: 'Cég', value: true }]}
                    value={this.props.address.is_company}
                    isNullable={false}
                    onChange={this.handleChange}
                    editingDisabled
                  />
              }
            </InputWrapper>
          </div>
          {this.props.address.is_company &&
            <div className={cg.cell}>
              <Input name="vat_number" label="Adószám *" type="text" placeholder="12345678-9-10" required textOnly={isGoodId} />
            </div>
          }
          <div className={cg.cell}>
            <Input name="name" label={this.props.address.is_company ? "Cégnév *" : "Név *"} type="text" autoComplete="name" placeholder="Számlázási név" required textOnly={isGoodId} />
          </div>
          <div className={cg.cell}>
            <Input name="postcode" label="Irányítószám *" type="text" placeholder="1111" required textOnly={isGoodId} />
          </div>
          <div className={cg.cell}>
            <Input
              name='city'
              type='text'
              label='Település *'
              placeholder='Település'
              textOnly={isGoodId}
            />
          </div>

          <div className={cg.cell}>
            <Input name="street" label="Közterület *" type="text" placeholder="Kossuth Lajos u." required textOnly={isGoodId} />
          </div>

          <div className={cg.cell}>
            <Input name="house_number" label="Házszám *" type="text" placeholder="11" required textOnly={isGoodId} />
          </div>
          { !this.props.fieldsOnly && !isGoodId &&
            <>
              <div className={cn(cg.cell)}>
                <div className={cn(cg.gridX, cg.gridMarginX, cg.alignMiddle)}>

                  <div className={cn(cg.cell, cg.small6, cg.textCenter, cg.mediumTextRight)}>
                    <Button className={cn(btnCss.hasMarginBottom, btnCss.largeWidth, btnCss.hollow)} label="Mégsem" onClick={this.props.onResetClick} disabled={isFetching} />
                  </div>

                  <div className={cn(cg.cell, cg.small6, cg.textCenter, cg.mediumTextLeft)}>
                    <Button className={cn(btnCss.hasMarginBottom, btnCss.largeWidth, btnCss.secondary)} label={!isNewAddress ? "Módosítás" : "Mentés"} onClick={this.props.onSaveClick} disabled={isFetching} />
                  </div>
                </div>

                {!isNewAddress && !this.props.hideDeleteButton && <div className={cn(cg.gridX, cg.gridMarginX, cl.marginTop)}><div className={cn(cg.cell, cg.small12, cg.textCenter)}>
                  <Button
                    className={cn(btnCss.delete, btnCss.link)}
                    label="Törlés"
                    renderIcon={{ ariaLabel: 'ariaLabel', Icon: <SVGTrashSmall width={21} height={21} title="Törlés" /> }}
                    onClick={this.props.onDeleteClick}
                    disabled={isFetching}
                  />
                </div></div>}
              </div>
            </>
          }
        </div>
      </fieldset>
    </Form>




  render() {
    const { address, opened, isFetching } = this.props
    const isNewAddress = address.id === NEW_ADDRESS_ID
    const isValidPostcode = this.state.cities.length > 0
    let formErrors = this.props.errors
    if (this.state.postcodeError) {
      formErrors = { ...formErrors, fieldErrors: {...formErrors.fieldErrors, postcode: this.state.postcodeError } }
    }

    if (this.props.fieldsOnly) {
      return this.renderForm(isNewAddress, isFetching, isValidPostcode, this.props.address.is_goodid)
    }

    return (
      <div className={!this.props.noDropDown ? cn(prnt.profileNav__listItem, cl.profileNav__listItemIsFoldable, cla.profileNav__listItem, { [cl.profileNav__listItemIsOpened]: opened }) : ''} ref={this.props.divRef}>
      <h3 className={cn(cg.gridX, cg.alignMiddle, prnt.listItem__gridX, { [cl.listItemIsFoldable__header]: !this.props.noDropDown })} onClick={this.props.onClick}>
          <span className={cn(cg.cell, cg.auto, prnt.cell, prnt.auto)}>
            {!isNewAddress ? formatAddressWithName(address) : 'Új cím'}
          </span>

          {address.is_goodid && <Badge label="GoodID" />}

          {!this.props.noDropDown && <span className={cn(cg.cell, cg.shrink, prnt.cell, prnt.shrink, cl.arrowWrapper)}>
            <span aria-hidden={true}>
              <SVGArrow width={24} height={24} />
            </span>
          </span>}
        </h3>

        <div className={cn(cg.cell, cg.medium8, cg.large9, cl.listItemIsFoldable__content)}>
          {this.renderForm(isNewAddress, isFetching, isValidPostcode, this.props.address.is_goodid)}
        </div>
      </div>
    )
  }
}

export default React.forwardRef<HTMLDivElement, OwnProps>((props: OwnProps, ref) => <BillingAddressForm divRef={ref} {...props} />)
